module.exports = new __parcel__URL__("beetlejuice-dick-cavett.f6d67d57.gif").toString();